import React from "react"

import { FormControl, FormHelperText, FormLabel, Select, Option } from "@mui/joy";
import { Controller } from "react-hook-form";
import { Icon } from '../../assets';
import { useTranslation} from 'react-i18next';
import { useEffect } from "react";
import { useDataProvider } from 'src/mtska-frontend-data-provider';

const InputSelect = ({editing, required, name, control, label, autoFocus, placeholder, type = "select", hint, icon, disabled, readonly, addEmptyOption = false, haserror, options, translateOptions = true, className = "", dataProvider, project, labelkey, filters = {}, sort = []}) => {
    const {t} = useTranslation();

    if (!editing) readonly = true;
    if (readonly) disabled = true;
    const { items, loadAll } = useDataProvider(dataProvider);

    useEffect(() => {
        if (!dataProvider) return

        const fetch = async () => {
            try {
                const compoundfilters = {};
                compoundfilters.items = filters?.items ?? [];
                compoundfilters.project = project ?? [];
                compoundfilters.sort = sort ?? [];

                loadAll(compoundfilters)
            } catch (e) {
                console.error('Errore nel caricamento dei dati:', e)
            }
        }

        fetch()
    }, [dataProvider])

    const finalOptions = dataProvider
        ? items.map((item) => ({
            value: item.value ?? item.id,
            label: item[labelkey] ?? item.name ?? item.id
        }))
        : options

    const generateOptions = () => {
        const source = Array.isArray(finalOptions) ? finalOptions : options || []
        return source.map((option, k) => (
            <Option key={k} value={option.value}>
                {translateOptions ? t(option.label) : option.label}
            </Option>
        ))
    }

    return (

        <Controller
            name={name}
            control={control}
            render={({
                field: { onChange, value, name },
                fieldState: { error, invalid },
                formState,
            }) =>  {
                let generalClass = "form-element-control";
                generalClass += (editing) ? " editing" : " reading";
                generalClass += (invalid) ? " error" : "";
                generalClass += (required) ? " required" : "";
                generalClass += (disabled) ? " disabled" : "";
                generalClass += (readonly) ? " readonly" : "";

                if  (typeof value == typeof undefined) {
                    className = className.replace(' filled', '').replace(' empty', '')+' empty';
                } else {
                    className = className.replace(' filled', '').replace(' empty', '')+' filled';
                }

                return (
                <div className={("form-element select "+className).trim()}>
                    <FormControl error={invalid} className={(error) ? generalClass + " form-element-error" : generalClass}>
                        <FormLabel className="form-element-label" htmlFor={name}>{t(label)}</FormLabel>
                        <Select
                            id={name}
                            type={type}
                            name={name}
                            value={value}
                            error={invalid}
                            onChange={(e, v) => { onChange(v); } }
                            variant="outlined"
                            autoComplete="off"
                            className="form-element-field form-element-field-select"

                            autoFocus={autoFocus}
                            placeholder={t(placeholder)}
                            disabled={disabled}
                            readOnly={readonly}
                            required={required}

                            startDecorator={(icon) ? (
                                <Icon icon={icon} />
                            ) : (
                                <></>
                            )}
                            endDecorator={(haserror || error) ? (
                                <Icon icon="faCircleExclamation" />
                            ) : (
                                <></>
                            )}
                        >
                            {addEmptyOption && (
                                <Option value="">Select</Option>
                            )}
                            {generateOptions()}
                        </Select>
                        <FormHelperText className="form-element-hint">
                            {(haserror || error) ? (
                                <>
                                    {error ? error.message : 'Messaggio di errore'}
                                </>
                            ) : (
                                <>
                                    {hint}
                                </>
                            )}
                        </FormHelperText>
                    </FormControl>
                </div>
            )}}
        />

    );
};

export default InputSelect;